import classNames from 'classnames/bind';
import { Caption } from 'koba/components/Typography';
import { useRouter } from 'next/router';
import { useTranslation } from 'react-i18next';
import { SORT_BY_PARAMS } from 'utils/constants';
import { pushRouteWithSortBy } from 'utils/routerHelpers';

import React from 'react';

import { ActionMenu } from '@thinkific/chalk/ActionMenu';
import { Button } from '@thinkific/chalk/Button';
import { CaretDown } from '@thinkific/chalk/react-icons';

import styles from './PostListSort.module.scss';
import { sortByTitle } from './helpers';

const cx = classNames.bind(styles);

export const PostListSort = () => {
  const router = useRouter();
  const { t } = useTranslation();
  const sortByFieldFromParams = Array.isArray(router.query.sortBy)
    ? router.query.sortBy[0]
    : router.query.sortBy || '';

  const handleChange = (sortBy: string) => () => {
    pushRouteWithSortBy(router, sortBy);
  };

  const sortingItems = Object.values(SORT_BY_PARAMS).map((sortByParam) => ({
    label: sortByTitle(sortByParam, t),
    onClick: handleChange(sortByParam),
  }));

  return (
    <div className={cx('post-list-sort__container')} data-qa="post-list-sort__container">
      <Caption className={cx('post-list-sort__caption', 'is-spaces-enabled')}>
        {t('Sort posts by')}
      </Caption>
      <ActionMenu dataQa="post-list-sort-menu" items={sortingItems}>
        <Button
          className={cx('post-list-sort__toggle', 'is-spaces-enabled')}
          data-qa="post-list-sort-toggle"
          emphasis="low"
          icon={CaretDown}
          size="sm"
        >
          {sortByTitle(sortByFieldFromParams, t)}
        </Button>
      </ActionMenu>
    </div>
  );
};

export default PostListSort;
